import { CardProps } from "./types";

/**
 * 通用卡片組件
 * 使用設計 Token 系統來確保視覺一致性
 */
export function Card({
  children,
  title,
  subtitle,
  headerAction,
  footer,
  elevation = "low",
  className = "",
  onClick,
}: CardProps) {
  // 使用 Tailwind CSS 類名替代 tokens 變數

  // 將樣式轉換為 Tailwind 類名
  const getTailwindClasses = () => {
    let classes = `
      bg-white dark:bg-gray-800
      rounded-lg
      transition-all
      ${onClick ? "cursor-pointer hover:shadow-md" : ""}
    `;

    // 根據海拏添加類
    if (elevation === "none") {
      classes += " shadow-none";
    } else if (elevation === "low") {
      classes += " shadow-sm";
    } else if (elevation === "medium") {
      classes += " shadow-md";
    } else if (elevation === "high") {
      classes += " shadow-lg";
    }

    return classes;
  };

  return (
    <div className={`${getTailwindClasses()} ${className}`} onClick={onClick}>
      {/* 卡片標題 */}
      {(title || headerAction) && (
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          <div>
            {title && (
              <h3 className="text-lg font-semibold text-text-primary">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="mt-1 text-sm text-text-secondary">{subtitle}</p>
            )}
          </div>
          {headerAction && <div>{headerAction}</div>}
        </div>
      )}

      {/* 卡片內容 */}
      <div className="p-4">{children}</div>

      {/* 卡片底部 */}
      {footer && (
        <div className="p-4 border-t border-gray-200 dark:border-gray-700">
          {footer}
        </div>
      )}
    </div>
  );
}
